import classes from "./ContentWindow.module.css";
import React, { PropsWithChildren } from "react";

const ContentWindow: React.FC<PropsWithChildren> = (props) => {
  return <div className={classes["content-window"]}>{props.children}</div>;
};

export default ContentWindow;
